import { gql } from '@apollo/client';

export const CLEAR_MESSAGE_COUNT = gql`
        mutation MyMutation($room_id:String!,$user_id:String!) {
            clearUnReadMessageCount(room_id: $room_id, user_id: $user_id)
        }
        
`;